import * as React from "react";
import { List, Datagrid, FunctionField, NumberField, Show, SimpleShowLayout } from "react-admin";
import { TechInfo } from "../../components/ui";

// ExerciseCategoryDTO : { id, exerciseCount } — l'identifiant EST le nom de
// la catégorie (pas de champ `name`).
const nameOf = (r) => r?.name || r?.label || r?.id || "—";

export default {
  list: () => (
    <List perPage={25}>
      <Datagrid rowClick="show" bulkActionButtons={false}>
        <FunctionField label="Catégorie" sortBy="id" render={nameOf} />
        <NumberField locales="fr-FR" source="exerciseCount" label="Exercices" />
      </Datagrid>
    </List>
  ),
  show: () => (
    <Show>
      <SimpleShowLayout>
        <FunctionField label="Catégorie" render={nameOf} />
        <NumberField locales="fr-FR" source="exerciseCount" label="Exercices" />
        <TechInfo />
      </SimpleShowLayout>
    </Show>
  ),
};
